<div class="w-full max-w-5xl p-8">
    <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px] flex flex-row">
        <button mat-button type="button" (click)="cancel()">
            <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
        </button>
        <h2 class="!mt-0 content-center">{{ getTitle() }}</h2>
    </div>
    <span class="separator-line block"></span>

    @if (infoTextConfig; as config) {
        <div class="mt-4 mb-8 border-l-4 border-primary-300 pl-4">
            <div class="flex gap-3">
                <mat-icon class="mt-0.5 text-primary-600 icon-size-5" [svgIcon]="'heroicons_outline:information-circle'"></mat-icon>

                <div class="min-w-0 flex-1">
                    <p class="m-0 text-md leading-6 text-secondary whitespace-pre-line">
                        {{ config.summaryTextKey | translate }}
                    </p>

                    @if ((config.detailTextKeys?.length ?? 0) > 0) {
                        <button
                            mat-button
                            type="button"
                            class="interest-register-info-toggle mt-2 !px-0"
                            (click)="showMoreInformation = !showMoreInformation"
                        >
                            <span class="text-sm font-medium">
                                {{ 'label_interest_register_more_information' | translate }}
                            </span>

                            <mat-icon
                                class="ml-1 icon-size-4 transition-transform"
                                [class.rotate-180]="showMoreInformation"
                                [svgIcon]="'heroicons_outline:chevron-down'"
                            >
                            </mat-icon>
                        </button>

                        @if (showMoreInformation) {
                            <div class="mt-2 space-y-3 text-sm leading-6 text-secondary">
                                @for (detailTextKey of config.detailTextKeys ?? []; track detailTextKey) {
                                    <p class="m-0 whitespace-pre-line">
                                        {{ detailTextKey | translate }}
                                    </p>
                                }
                                @if (config.linkUrl && config.linkTextKey) {
                                    <p class="m-0">
                                        @if (config.linkIntroTextKey) {
                                            <span>{{ config.linkIntroTextKey | translate }} </span>
                                        }

                                        <a class="c-link" [href]="config.linkUrl" target="_blank" rel="noopener noreferrer">
                                            {{ config.linkTextKey | translate }}
                                        </a>
                                    </p>
                                }
                            </div>
                        }
                    }
                </div>
            </div>
        </div>
    }

    <form class="mt-8" [formGroup]="form" (ngSubmit)="submit()">
        @switch (entryType) {
            @case (InterestRegisterEntryType.ConflictOfInterest) {
                <app-conflict-of-interest-form [form]="form"></app-conflict-of-interest-form>
            }

            @case (InterestRegisterEntryType.GiftOrTravel) {
                <app-gift-or-travel-form [form]="form"></app-gift-or-travel-form>
            }

            @case (InterestRegisterEntryType.EmploymentOrBoardParticipation) {
                <app-employment-or-board-participation-form [form]="form"></app-employment-or-board-participation-form>
            }

            @case (InterestRegisterEntryType.SecuritiesTrading) {
                <app-securities-trading-form [form]="form"></app-securities-trading-form>
            }

            @case (InterestRegisterEntryType.InterDepartmentTrading) {
                <app-interdepartment-trading-form [form]="form"></app-interdepartment-trading-form>
            }
        }

        <div class="mt-8">
            <label class="block font-medium mb-2">Viðhengi ef við á</label>

            <label
                class="interest-register-upload"
                [class.interest-register-upload-dragging]="isDraggingAttachment"
                (dragover)="onAttachmentDragOver($event)"
                (dragleave)="onAttachmentDragLeave($event)"
                (drop)="onAttachmentDrop($event)"
            >
                <input
                    class="hidden"
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png,.doc,.docx,.xls,.xlsx,.msg,.eml,.txt"
                    multiple
                    (change)="onFilesSelected($event)"
                />
                <span>Velja eða draga inn viðhengi</span>
                <mat-icon [svgIcon]="'heroicons_outline:document'"></mat-icon>
            </label>

            @if (selectedFiles.length > 0) {
                <div class="mt-4 rounded-xl bg-card shadow border overflow-hidden">
                    @for (file of selectedFiles; track file.name + file.size) {
                        <div class="flex items-center justify-between px-4 py-3 border-b last:border-b-0">
                            <div class="min-w-0">
                                <div class="font-medium truncate">{{ file.name }}</div>
                                <div class="text-sm text-secondary">{{ file.size / 1024 | number: '1.0-0' }} KB</div>
                            </div>

                            <button mat-icon-button type="button" (click)="removeFile(file)" [matTooltip]="'Fjarlægja viðhengi'">
                                <mat-icon [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                            </button>
                        </div>
                    }
                </div>
            }
        </div>

        @if (attachmentError) {
            <div class="mt-4 text-red-600">
                {{ attachmentError }}
            </div>
        }

        <div class="mt-8 flex justify-end gap-3">
            <button mat-button type="button" (click)="cancel()">Hætta við</button>

            <button mat-flat-button color="primary" type="submit" [disabled]="isSubmitting">
                @if (isSubmitting) {
                    <mat-progress-spinner class="mr-2" [diameter]="16" [mode]="'indeterminate'"></mat-progress-spinner>
                }
                Skrá
            </button>
        </div>
    </form>
</div>
